// extracted by mini-css-extract-plugin
module.exports = {"newsDetail":"NewsDetail_newsDetail__m8uuN","readingTime":"NewsDetail_readingTime___KzzH","details":"NewsDetail_details__3ccXN"};